<template>
  <van-popup
    class="commodity-popup"
    :value="detailsVisible"
    position="bottom"
    closeable
    @click-close-icon="close"
    @click-overlay="close"
  >
    <div class="popup-wrapper">
      <div class="popup-title">大宗物料</div>
      <div class="popup-body">
        <hi-card v-for="(item, index) in commodityList" :key="item.id || index" :row-index="index + 1">
          <div class="row-item">
            <span class="label">大宗物料编码:</span>
            <span class="value">{{ item.commodityCode }}</span>
          </div>
          <div class="row-item">
            <span class="label">大宗物料名称:</span>
            <span class="value">{{ item.commodityName }}</span>
          </div>
          <div class="row-item">
            <span class="label">原行情单价:</span>
            <span class="value">{{ item.originQuotationPrice }}</span>
          </div>
          <div class="row-item">
            <span class="label">最新行情单价:</span>
            <span class="value">{{ item.quotationPrice }}</span>
          </div>
          <div class="row-item">
            <span class="label">原与供方约定单价:</span>
            <span class="value">{{ item.originSupplyPrice }}</span>
          </div>
          <div class="row-item">
            <span class="label">现与供方约定单价:</span>
            <span class="value">{{ item.supplyPrice }}</span>
          </div>
          <div class="row-item">
            <span class="label">原上下限行情边界:</span>
            <span class="value">{{ item.originBounding }}</span>
          </div>
          <div class="row-item">
            <span class="label">现上下限行情边界:</span>
            <span class="value">{{ item.bounding }}</span>
          </div>
          <div class="row-item">
            <span class="label">原行情单位:</span>
            <span class="value">{{ item.originQuotationUnit }}</span>
          </div>
          <div class="row-item">
            <span class="label">现行情单位:</span>
            <span class="value">{{ item.quotationUnit }}</span>
          </div>
          <div class="row-item">
            <span class="label">原核价单位:</span>
            <span class="value">{{ item.originPriceUnit }}</span>
          </div>
          <div class="row-item">
            <span class="label">现核价单位:</span>
            <span class="value">{{ item.priceUnit }}</span>
          </div>
          <div class="row-item">
            <span class="label">原单位转换比:</span>
            <span class="value">{{ item.unitTransRatio }}</span>
          </div>
          <div class="row-item">
            <span class="label">现单位转换比:</span>
            <span class="value">{{ item.originUnitTransRatio }}</span>
          </div>
        </hi-card>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'LinkagePriceAdjustCommodityDialog',
  props: {
    detailsVisible: {
      type: Boolean,
      default: false
    },
    commodityList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    close() {
      this.$emit('close-details-dialog')
    }
  }
}
</script>

<style lang="scss" scoped>
.commodity-popup {
  height: 90vh;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow: hidden;
}
.popup-wrapper {
  height: 90vh;
  display: flex;
  flex-direction: column;
  position: relative;
}
.popup-title {
  text-align: center;
  padding: 0 40px;
  height: 46px;
  line-height: 46px;
  font-size: 17px;
  font-weight: 500;
  color: #333;
}
.popup-body {
  flex: 1;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 0 10px;
  background: #f7f8fa;
}
.row-item {
  display: flex;
  align-items: flex-start;
  padding: 1px 0;
  box-sizing: border-box;
}
.label {
  width: 155px;
  color: #666666;
  flex-shrink: 0;
}
.value {
  flex: 1;
  color: #262626;
  word-break: break-all;
}
.commodity-popup :deep(.van-popup__close-icon) {
  top: 11px;
}
:deep(.custom-card) {
  margin: 10px 5px;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
:deep(.row-index) {
  top: 0;
  right: 0;
  width: 18px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1px;
  box-sizing: border-box;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: #409eff;
  color: #fff;
}
</style>
